export default "__VITE_ASSET__DT2XnZAX__"